import React, { useState } from 'react';
import {
  IonContent,
  IonPage,
  IonButton,
  IonIcon,
  IonAlert,
} from '@ionic/react';
import AppHeader from '../components/AppHeader';
import AccountHeader from '../components/AccountHeader';
import './Home.scss';
import { Laboratory, User } from '../models';
import {
  APPOINTMENT_ROUTE,
  COVID_APPOINTMENT_ROUTE
} from '../navigators/AppStackNavigator';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import isDateBetween from '../utils/isDateBetween';
import { login } from '../store/actions/authentication';
import { AuthenticationParams } from '../repositories/AuthenticationRepository';

type HomeProps = {
  laboratorySlug?: string;
  laboratories?: Laboratory[];
  accessToken?: string | null;
  user?: User | null;
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  login: (params: AuthenticationParams) => dispatch(login(params)),
});

const Home: React.FC<
  HomeProps &
    ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>
> = ({ laboratories, accessToken, user, login }) => {
  const regularAppointmentLaboratory = laboratories?.find(
    (laboratory) => !laboratory.covid
  );
  const covidAppointmentLaboratory = laboratories?.find(
    (laboratory) => laboratory.covid
  );
  const history = useHistory();
  const [showBox, setShowBox] = useState(!!accessToken);
  const message =
    'À compter du 1er janvier, les cartes de mutuelle doivent être renouvelées.';
  const today = new Date();
  const currentYear = today.getFullYear();
  // January 1st of the current year
  const startDate = new Date(currentYear, 0, 1);
  // March 1st of the current year
  const endDate = new Date(currentYear, 2, 1);
  const hasMutual = user && user.patient && user.patient.documents.mutual;
  const isInsuranceModal =
    !!accessToken && isDateBetween(today, endDate, startDate) && !hasMutual;

  return (
    <IonPage>
      <AppHeader />
      <IonContent class="ion-padding">
        <div className="wrapper wrapper--medium wrapper--stretch wrapper--centered-md">
          <div className="ion-hide-lg-up">
            <AccountHeader />
          </div>
          {isInsuranceModal && (
            <IonAlert
              cssClass={'prescription-popup'}
              isOpen={showBox}
              onDidDismiss={() => setShowBox(false)}
              message={message}
              buttons={[
                {
                  text: 'Envoyer ma nouvelle carte',
                  handler: () => {
                    history.push('/dashboard/mon-compte');
                  }
                },
                {
                  text: "Ignorer pour l'instant",
                  handler: () => {}
                }
              ]}
            />
          )}
          <div className="home-card">
            <header className="home-card__header ion-margin-bottom">
              <div className="home-card__header__title ion-margin-bottom">
                <h1>Bienvenue sur</h1>
                <img
                  src={require('../assets/images/logo-unilabs-le-pass.svg')}
                  alt="Le Pass"
                />
              </div>
              <p className="home-card__intro">
                Préparez votre venue{' '}
                {regularAppointmentLaboratory
                  ? `à ${regularAppointmentLaboratory.name}`
                  : 'en Laboratoire'}
                <br />
                Pré enregistrez-vous et réservez un créneau horaire de prise en
                charge
              </p>
            </header>
            <div className="home-card__buttons ion-margin-bottom">
              <div>
                <IonButton
                  routerLink={`${APPOINTMENT_ROUTE}/laboratoire${
                    regularAppointmentLaboratory
                      ? `/${regularAppointmentLaboratory.slug}`
                      : ''
                  }`}
                  expand="block"
                  size="large"
                  color="primary"
                  class="large"
                  routerDirection="forward"
                  onClick={() => {}}
                  disabled={
                    regularAppointmentLaboratory &&
                    regularAppointmentLaboratory.appointment_type === 'none'
                  }
                >
                  <div className="home-card__inner-button">
                    <IonIcon src={require('../assets/icons/tube.svg')} />
                    <span>
                      Une analyse de biologie{' '}
                      <small>(hors test PCR COVID)</small>
                    </span>
                  </div>
                </IonButton>
              </div>
              <div>
                <IonButton
                  routerLink={`${COVID_APPOINTMENT_ROUTE}/laboratoire${
                    covidAppointmentLaboratory
                      ? `/${covidAppointmentLaboratory.slug}`
                      : ''
                  }`}
                  expand="block"
                  size="large"
                  color="primary"
                  class="large"
                  routerDirection="forward"
                  onClick={() => {}}
                  disabled={
                    covidAppointmentLaboratory &&
                    covidAppointmentLaboratory.appointment_type === 'none'
                  }
                >
                  <div className="home-card__inner-button">
                    <IonIcon src={require('../assets/icons/covid.svg')} />
                    <span>Un test PCR COVID-19</span>
                  </div>
                </IonButton>
              </div>
            </div>
            <IonButton routerLink="/dashboard/faq" expand="block" color="light">
              Foire aux questions
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state: {
  authentication: AuthenticationRootState;
}) => {
  return {
    accessToken: state.authentication.accessToken,
    user: state.authentication.user
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
